<template>
  <div class="text-start">

    <nav class="border-b border-gray-300 px-2 md:px-0 py-2">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'splash_pages'}">splash pages</router-link>
            <span class="mx-2">/</span>
            <span>create</span>
          </div>
          <div class="text-xl">
            New splash page
          </div>
        </div>
      </div>
    </nav>
    <div class="py-4">
      <div class="border p-4 rounded mt-4 overflow-auto">
        <UpdateOrCreateSplashPageComponent/>
      </div>
    </div>
  </div>
</template>
<script>
import UpdateOrCreateSplashPageComponent from "../../components/UpdateOrCreateSplashPageComponent";

export default {
  name: "CreateSplashPage",
  components: { UpdateOrCreateSplashPageComponent},
  props: {
    id: String
  },
  data() {
    return {
      loading: false,
      errors: []
    }
  },

  mounted() {
    this.$root.$on("page_created", () => {
      this.$router.push({message: 'splash_pages'});
    });
  },
  methods: {}
}
</script>
<style scoped>
</style>